import { css } from 'lit';
import componentStyles from '../styles/component.styles';
export default css `
${componentStyles}
/**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
  display: block;
}

.tree {
  margin-bottom: var(--mf-folder-tree-margin, 20px);
}

h2 {
  padding-left: 25px;
  font-family: var(--p-h6-font);
  font-size: var(--p-h6-font-size);
  font-weight: var(--p-h6-font-weight);
  font-style: var(--p-h6-font-style);
  line-height: var(--p-h6-line-height);
  text-transform: var(--p-h6-transform);
  letter-spacing: var(--p-h6-letter-spacing);
  margin: 0 0 .5em;
}

`;
